import React from 'react';
import * as R from 'ramda';
import {Input} from 'reactstrap';
import TextMask from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const maskConfig = {
  date: {
    mask: R.flatten([
      R.repeat(/\d/, 4),
      '/',
      R.repeat(/\d/, 2),
      '/',
      R.repeat(/\d/, 2),
    ]),
    raw: R.compose(
      R.replace(/\/\//g, ''),
      R.replace(/_/g, '')
    ),
  },
  number: {
    mask: createNumberMask({prefix: ''}),
    raw: R.replace(/,/g, ''),
  },
  'number.': {
    mask: createNumberMask({prefix: '', allowDecimal: true, decimalLimit: 9}),
    raw: R.replace(/,/g, ''),
  },
  'number.2': {
    mask: createNumberMask({prefix: '', allowDecimal: true, decimalLimit: 2}),
    raw: R.replace(/,/g, ''),
  },
};

const unmask = mask => R.path([mask, 'raw'], maskConfig) || R.identity;

const MaskedInput = ({mask, ...rest}) => (
  <Input tag={TextMask} mask={maskConfig[mask].mask} {...rest} />
);

export {unmask};
export default MaskedInput;
